// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 21/08/2025
import { docodeHexResponse } from '../../../_common/common.utils';
import BalanceSheetType from './balance-sheet.types';

const INITIAL_STATE = {
	profitLossReportResp: null,
	profitLossReportArr: [],

	balanceSheetReportArr: [],
	balanceSheetReportResp: null,
};

const balanceSheetReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET PROFIT LOSS REPORT START *********************** */
		case BalanceSheetType.GET_PROFIT_LOSS_REPORT_SUCCESS:
			return {
				...state,
				profitLossReportResp: action.payload,
				profitLossReportArr: docodeHexResponse(action.payload, 'GetProfitLossReportKey'),
			};

		case BalanceSheetType.GET_PROFIT_LOSS_REPORT_FAILURE:
			return { ...state, profitLossReportResp: action.payload };

		case BalanceSheetType.GET_PROFIT_LOSS_REPORT_RESPONSE_CHANGED:
			return { ...state, profitLossReportResp: null };
		/** ***************** GET  PROFIT LOSS REPORT END *********************** */

		/** ***************** GET BALANCE SHEET REPORT START *********************** */
		case BalanceSheetType.GET_BALANCE_SHEET_REPORT_SUCCESS:
			return {
				...state,
				balanceSheetReportResp: action.payload,
				balanceSheetReportArr: docodeHexResponse(
					action.payload,
					'GetBalanceSheetReportKey',
				),
			};

		case BalanceSheetType.GET_BALANCE_SHEET_REPORT_FAILURE:
			return { ...state, balanceSheetReportResp: action.payload };

		case BalanceSheetType.GET_BALANCE_SHEET_REPORT_RESPONSE_CHANGED:
			return { ...state, balanceSheetReportResp: null };
		/** ***************** GET  BALANCE SHEET REPORT END *********************** */

		default:
			return state;
	}
};

export default balanceSheetReducer;
